export const NA = 'na';

export const AcceptanceValue = {
    PASS: 1,
    FAIL: -1,
    NEUTRAL: 0
};

export const ACCEPTANCE_CRITERIA_OPERATORS = {
    GT_OP: '>',
    GTE_OP: '>=',
    LT_OP: '<',
    LTE_OP: '<=',
    BETWEEN_OP: 'between',
    INCLUSIVE_BETWEEN_OP: 'inclusive_between'
};

export const CONDITION_OPERATORS_AND_INSTRUCTIONS = {
    '>': 'mobile_field_temperature_greater_range',
    '>=': 'mobile_field_temperature_greater_or_equal_range',
    '<': 'mobile_field_temperature_less_range',
    '<=': 'mobile_field_temperature_less_or_equal_range',
    between: 'mobile_field_temperature_between_range',
    inclusive_between: 'mobile_field_temperature_inclusive_between_range'
};

export const ReadingMethod = {
    MANUAL: 'manual',
    PROBE: 'probe',
    SENSOR: 'sensor'
};
